// ClubNeedsBanner — surfaces the top club-needs hints (from
// staffEffects.assessClubNeeds) so the player knows what the club is
// missing without digging through panels.

import { useGameStore } from '@/store/gameStore'
import { assessClubNeeds } from '@/game/systems/staffEffects'
import { ROSTER_RULES } from '@/config/playersConfig'
import { AlertTriangle, Info, Siren } from 'lucide-react'

const SEVERITY_UI = {
  urgent: { icon: Siren, color: 'var(--danger)' },
  warn: { icon: AlertTriangle, color: 'var(--warning)' },
  info: { icon: Info, color: 'var(--text-secondary)' },
} as const

const MAX_SHOWN = 3

export function ClubNeedsBanner() {
  const staff = useGameStore(s => s.staff)
  const players = useGameStore(s => s.players)
  const courts = useGameStore(s => s.courts)
  const league = useGameStore(s => s.league)
  const enabledServices = useGameStore(s => s.enabledServices)

  const needs = assessClubNeeds({
    staff,
    players,
    courts,
    hasLeague: league !== null,
    leagueMinPlayers: ROSTER_RULES.leagueMinPlayers,
    cafeteriaEnabled: enabledServices.includes('cafeteria'),
  }).slice(0, MAX_SHOWN)

  if (needs.length === 0) return null

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', marginBottom: '0.75rem' }}>
      {needs.map(need => {
        const ui = SEVERITY_UI[need.severity]
        const Icon = ui.icon
        return (
          <div
            key={need.id}
            className="hint-box"
            style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}
          >
            <Icon size={15} style={{ color: ui.color, flexShrink: 0, marginTop: '2px' }} />
            <span>{need.message}</span>
          </div>
        )
      })}
    </div>
  )
}
